
import React, { useState } from "react";
import { Modal, Table, Button, Input, Select, Spin } from "antd";
import {
  CloseOutlined,
  DownloadOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import "./dashboardCss.css";
import { useSelector } from "react-redux";

const { Option } = Select;

interface NewDashboardProps {
  visible: boolean;
  handleClose: any;
  schemeTableData: DataType[];
  isLoading: boolean;
  downloadDoc: any;
  downloadLoading: boolean;
}

interface DataType {
  serialNo: number;
  name: string;
  creditNo: string;
  opNo: string;
  billNo: string;
  dod: string;
  caseId: string;
  status: string;
  billAmount: string;
}

const columns = [
  { title: "Sr. No.", dataIndex: "serialNo", key: "serialNo", width: 80 },
  { title: "Name", dataIndex: "name", key: "name" },
  { title: "CR NO", dataIndex: "creditNo", key: "creditNo" },
  { title: "OP NO.", dataIndex: "opNo", key: "opNo" },
  // { title: "BILL No.", dataIndex: "billNo", key: "billNo" },
  { title: "DOD", dataIndex: "dod", key: "dod" },
  { title: "Case ID", dataIndex: "caseId", key: "caseId" },
  { title: "Status", dataIndex: "status", key: "status" },
  { title: "Bill Amount", dataIndex: "billAmount", key: "billAmount" },
];

const NewDashboardSchemeModal: React.FC<NewDashboardProps> = ({
  visible,
  handleClose,
  schemeTableData,
  isLoading,
  downloadDoc,
  downloadLoading,
}) => {
  const data: DataType[] = schemeTableData;
  const { isFetchingSchemeTableData, isFetchingCghsStatusTable } = useSelector(
    (state: any) => state.dashboard
  );
  return (
    <Modal
      wrapClassName="eww-modal"
      loading={isLoading}
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#F2F9F9",
            borderRadius: "10px 10px 0px 0px",
            padding: "10px 20px",
            borderBottom: "0.5px solid #575757",
          }}
        >
          <span style={{ color: "rgb(242, 249, 249)" }}>CGHS OP</span>
          <div
            style={{
              display: "flex",

              alignItems: "center",
            }}
          >
            <Button
              icon={<PrinterOutlined />}
              style={{
                background: "none",
                boxShadow: "none",
                border: "none",
                textTransform: "initial",
              }}
            >
              <span style={{ textTransform: "initial" }}>Print</span>
            </Button>
            <Spin spinning={downloadLoading}>
              <Button
                icon={<DownloadOutlined />}
                onClick={() => downloadDoc()}
                style={{
                  background: "none",
                  boxShadow: "none",
                  border: "none",
                  textTransform: "initial",
                }}
              >
                <span style={{ textTransform: "initial" }}>Download</span>
              </Button>
            </Spin>
            <Button
              icon={<CloseOutlined />}
              onClick={handleClose}
              style={{
                background: "none",
                boxShadow: "none",
                border: "none",
                fontSize: "0.5rem",
              }}
            ></Button>
          </div>
        </div>
      }
      open={visible}
      onCancel={handleClose}
      centered
      closeIcon={null}
      footer={null}
      width={1500}
    >
      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "12px 24px 20px",
          borderBottom: "0.5px solid #575757",
          marginBottom: "10px",
        }}
      >
        <div>
          <Select
            placeholder="FilterName..."
            style={{ width: 120, marginRight: 10 }}
          >
            <Option value="select">SELECT</Option>
          </Select>
          <Select
            placeholder="FilterName..."
            style={{ width: 120, marginRight: 10 }}
          >
            <Option value="select">SELECT</Option>
          </Select>
          <Select
            placeholder="FilterName..."
            style={{ width: 120, marginRight: 10 }}
          >
            <Option value="select">SELECT</Option>
          </Select>
          <Select
            placeholder="FilterName..."
            style={{ width: 120, marginRight: 10 }}
          >
            <Option value="select">SELECT</Option>
          </Select>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Input
            className="custom-placeholder"
            placeholder="Type to search"
            // value={searchString || ""}
            // onChange={onSearchNameChange}
            // onKeyDown={onKeyDown}
            suffix={<SearchOutlined />}
            style={{
              height: "30px",
              border: "1px solid #808184",
              width: "300px",
            }}
          />
        </div>
      </div> */}
      <div className="new-dashboard" style={{ padding: "10px 24px" }}>
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={isFetchingCghsStatusTable }
          bordered
          style={{ overflowY: "auto", marginBottom: "10px" }}
        />
      </div>
    </Modal>
  );
};

export default NewDashboardSchemeModal;